/** Site origin for canonical URLs, Open Graph, and sitemaps. */
export const SITE_ORIGIN = 'https://buildconstrux.com';

export const SITE_NAME = 'Construx';
export const SITE_TAGLINE = 'Precision manufactured framing systems';
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/logo512.png`;

export function absoluteUrl(path = '/') {
  if (!path) return SITE_ORIGIN;
  if (path.startsWith('http')) return path;
  return `${SITE_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}
